"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _Loading = require("./Loading.styles");

var Loading = function Loading(_ref) {
  var className = _ref.className,
      fullscreen = _ref.fullscreen,
      text = _ref.text;
  return /*#__PURE__*/_react["default"].createElement(_Loading.StyledLoading, {
    className: className,
    fullscreen: fullscreen
  }, text && /*#__PURE__*/_react["default"].createElement(_Loading.StyledText, null, text), /*#__PURE__*/_react["default"].createElement(_Loading.StyledSpinner, null));
};

Loading.defaultProps = {
  className: '',
  fullscreen: false,
  text: undefined
};
Loading.propTypes = {
  /** Custom class to be added to the loading container */
  className: _propTypes.string,

  /** Sets if the loading container should fill up the viewport */
  fullscreen: _propTypes.bool,

  /** Text to added to the loading container */
  text: _propTypes.string
};
Loading.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Loading",
  "props": {
    "className": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "Custom class to be added to the loading container",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "fullscreen": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Sets if the loading container should fill up the viewport",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "text": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Text to added to the loading container",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var _default = Loading;
exports["default"] = _default;